export default "__VITE_ASSET__DksRCduK__"